// GENERATED by scripts/build-icons.mjs from icons/waypoints.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Waypoints = createIcon('waypoints', [
  ['path', { d: "m10.586 5.414-5.172 5.172" }],
  ['path', { d: "m18.586 13.414-5.172 5.172" }],
  ['path', { d: "M6 12h12" }],
  ['circle', { cx: "12", cy: "20", r: "2" }],
  ['circle', { cx: "12", cy: "4", r: "2" }],
  ['circle', { cx: "20", cy: "12", r: "2" }],
  ['circle', { cx: "4", cy: "12", r: "2" }],
])
